import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Sem StrictMode de proposito: a Digi roda a logica de interacao uma unica vez
// num effect (StrictMode duplicaria o bind em dev).
createRoot(document.getElementById('root')).render(<App />);
